module.exports = __webpack_public_path__ + "img/favourites-light-unselected.70479a7b.svg";